var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgUserGroupFill = function SvgUserGroupFill(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,26 C12,33.8598428 16.1931761,41.1226373 23,45.0525588 C29.8068236,48.9824804 38.1931764,48.9824804 45,45.0525588 C51.8068239,41.1226373 56,33.8598428 56,26 C56,13.8497354 46.1502645,4 34,4 C21.8497355,4 12,13.8497354 12,26 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6677859,42 L32.2703256,42 C14.443439,42 0,56.779831 0,75.0219111 C0,80.5274548 4.37074881,85 9.75098528,85 L68.3456431,85 C72.5721795,85 76,81.4923443 76,77.1673703 L76,70.9920802 C76,54.9862724 63.3092979,42 47.6677859,42 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6068733,14.1751126 C60.6068733,19.4949484 58.7139524,24.3591238 55.5739306,28.106931 C55.2064813,28.5398085 55.2287509,29.1891246 55.61847,29.6106106 C58.3353682,32.4926629 62.1546146,34.2811302 66.3747146,34.2811302 C74.6812974,34.2811302 81.4067337,27.3664828 81.3510599,18.8570238 C81.2953855,10.5412205 74.6812974,3.74048823 66.5528723,3.64935614 C64.2590975,3.62657311 62.0878056,4.1164081 60.1392105,5.03912052 C59.4488511,5.36947435 59.1036714,6.17827166 59.3597725,6.90732838 C60.172615,9.16284761 60.6068733,11.6120226 60.6068733,14.1751126 Z",
    transform: "translate(68.331556, 18.964863) rotate(-21.000000) translate(-68.331556, -18.964863) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1126377,41 L69.8565795,41 C68.990011,41 68.6719039,42.3066819 69.417811,42.8218161 C77.8970191,48.5888063 83.5790755,59.1804682 83.5790755,71.3049686 L83.5790755,78.3535122 C83.5790755,80.2507136 83.0635219,82.0097085 82.1750154,83.4671613 C81.7801232,84.1079383 82.1750154,85 82.8660761,85 L93.0016365,85 C96.8628025,85 100,81.4066244 100,76.984009 L100,70.6767561 C100,54.2804111 88.4055331,41 74.1126377,41 L74.1126377,41 Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgUserGroupFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "user-group-fill.ec2935f60d0eddbfba0c441a5c53d8f8.svg";